module.exports = new __parcel__URL__("../images/amo.3c2e8ce0.png").toString();